import { RegistrationFlowContext } from '@rhg/providers/registration';
import { useState, useContext } from 'react';
import { useConsentContext } from '../use-consent-context';
import { ConsentFlow, ConsentTypes } from '../use-consent-context/types';
import {
    ConsentTypeRegistrationStepMap,
    getConsentRegistrationStepMiraculouslyWorks,
    RegistrationFlow,
    RegistrationFlowContextProps,
    RegistrationFlowContextState,
    RegistrationForcedError,
    SkippedSponsorshipStep,
} from './types';

/** This one fails?????? https://calmdotcom.atlassian.net/browse/EVE-8642 */
export const getConsentRegistrationStep =
    getConsentRegistrationStepMiraculouslyWorks;

/** For some reason declaring this function here makes it miraculously fail https://calmdotcom.atlassian.net/browse/EVE-8642 */
export function getConsentRegistrationStepMiraculouslyFails(
    consentType?: ConsentTypes
) {
    return consentType && ConsentTypeRegistrationStepMap[consentType]
        ? ConsentTypeRegistrationStepMap[consentType]
        : undefined;
}

export function useRegistrationFlowContext(
    props: RegistrationFlowContextProps
): RegistrationFlowContextState {
    const {
        account,
        accessCodeSponsor,
        invitationSponsor,
        accountConsents,
        accountUserConsents,
        circleConsents,
        registrationFlow,
        isPostEligibility,
    } = props;

    const [skippedSponsorshipStep, setSkippedSponsorshipStep] =
        useState<SkippedSponsorshipStep>();
    const [forcedError, setForcedError] = useState<
        RegistrationForcedError | undefined
    >();

    const newSponsor = invitationSponsor ?? accessCodeSponsor;

    const hasSetCountry = !!account?.countryCode;

    const consentContext = useConsentContext({
        accountConsents,
        accountUserConsents,
        sponsorConsents: newSponsor?.consentConfigs,
        currentSponsorConsents: circleConsents,
        shouldUseCurrentSponsor: isPostEligibility
            ? ConsentFlow // Use all consents from the current sponsor since they are now our only sponsor
            : registrationFlow === RegistrationFlow.LossOfSponsorship
            ? ['healthcare_portability']
            : undefined,
    });
    const nextConsentStep = getConsentRegistrationStepMiraculouslyWorks(
        consentContext.nextConsentType
    );

    return {
        ...props,
        ...consentContext,
        nextConsentStep,
        newSponsor,
        isPostEligibility,
        hasSetCountry,
        skippedSponsorshipStep,
        setSkippedSponsorshipStep,
        forcedError,
        setForcedError,
    };
}

/** Uses context from the closest <RegistrationFlowProvider> */
export function useProvidedRegistrationFlowContext() {
    return useContext(RegistrationFlowContext);
}
